import { useEffect, useState } from 'react'

// Lags a value by `timeout` ms (0 snaps immediately). Pass a primitive or stable
// reference so changes compare correctly.
export function useLaggedValue<T>(value: T, timeout: number): T {
  const [lagged, setLagged] = useState(value)

  useEffect(() => {
    if (timeout === 0) {
      setLagged(value)
      return
    }
    const timer = setTimeout(() => setLagged(value), timeout)
    return () => clearTimeout(timer)
  }, [value, timeout])

  return lagged
}
